// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// Copyright (c) Utrecht University (Department of Information and Computing Sciences)

import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";
import { store } from "@/store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    meta: { requiresAuth: false },
    component: Home,
  },
  {
    path: "/redirect",
    name: "LoginRedirect",
    meta: { requiresAuth: true },
    component: () => import("../views/LoginRedirect.vue"),
  },
  {
    path: "/docent",
    name: "Teacher",
    meta: { requiresAuth: true },
    component: () => import("../views/Teacher.vue"),
    children: [
      {
        path: "/docent/klassen",
        name: "Classes",
        meta: { requiresAuth: true },
        component: () => import("../views/Classes.vue"),
      },
      {
        path: "/docent/lespakketten",
        name: "Lesson packages",
        meta: { requiresAuth: true },
        component: () => import("../views/LessonPackages.vue"),
      },
      {
        path: "/docent/levels",
        name: "Docent levels",
        meta: { requiresAuth: true },
        component: () => import("../views/TeacherLevels.vue"),
      },
      {
        path: "/docent/levelmaker",
        name: "Level maker",
        meta: { requiresAuth: true },
        component: () => import("../views/LevelMaker.vue"),
      },
      {
        path: "/docent/classroompackages",
        name: "Classroom Packages",
        meta: { requiresAuth: true },
        component: () => import("../views/ClassroomPackages.vue"),
      },
    ],
  },
  {
    path: "/levels",
    name: "Levels",
    meta: { requiresAuth: true },
    component: () => import("../views/Levels.vue"),
  },
  {
    path: "/prestaties",
    name: "Achievements",
    meta: { requiresAuth: true },
    component: () => import("../views/Achievements.vue"),
  },
  {
    path: "/wiki",
    name: "Wiki",
    meta: { requiresAuth: false },
    component: () => import("../views/Wiki.vue"),
  },
  {
    path: "/user",
    name: "User",
    meta: { requiresAuth: true },
    component: () => import("../views/User.vue"),
    children: [
      {
        path: "/user/profiel",
        name: "Profile",
        meta: { requiresAuth: true },
        component: () => import("../views/Profile.vue"),
      },
      {
        path: "/user/instellingen",
        name: "Settings",
        meta: { requiresAuth: true },
        component: () => import("../views/Settings.vue"),
      },
    ],
  },
  {
    path: "/game",
    name: "Game",
    meta: { requiresAuth: true },
    component: () => import("../views/Game.vue"),
  },
  {
    path: "/gameredirect",
    name: "Gameredirect",
    meta: { requiresAuth: true },
    component: () => import("../views/GameRedirect.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    // If true: this route requires auth
    to.matched.some((record) => record.meta.requiresAuth) &&
    // If true: user has not compleated login process
    store.getters.getAuthTokens === undefined &&
    // If true: user is not in the process of logging in
    new URLSearchParams(window.location.search).get("code") === null
  ) {
    // Redirect to login page.
    location.href = process.env.VUE_APP_SERVER_BASE + "/auth/login";
  }
  next();
});

//coordinating wiki pages
// router.beforeEach((to, from, next) => {
//   const params = to.path.split('/');
//   if (params.length > 3){
//     if (params[0] == "wiki"){
//         store.state.wikiSide = params[1];
//         store.state.wikiBookmark = params[2];
//         store.state.wikiItem = params[3];
//         console.log(params);
//       location.href = process.env.VUE_APP_SERVER_BASE + "/wiki";
//     }
//   }
//   next();
// });

export default router;
